import { boot } from '@dazn/bootstrap-lib';

import { SetCurrentChapter } from '../../public-api/lib/SetCurrentChapter';

type ChapterName = boot.config.ChapterName;

export const handlePopstate = (
    setCurrentChapter: SetCurrentChapter,
    currentChapter: ChapterName | undefined,
    chapterName: ChapterName,
    chapterPath = '',
) => {
    if (chapterName === currentChapter) {
        return;
    }
    const ignoreBrowserHistory = true;
    setCurrentChapter(
        {
            chapterName,
            chapterPath,
        },
        ignoreBrowserHistory,
    );
};
